import Input from "@hudson/ui/components/FormFields/Input";
import Field from "@hudson/ui/components/FormFields/Field";

function ResNumber({
  autoFocus,
  errorMessage,
  fieldName,
  label,
  requiredPlaceholder,
}: {
  autoFocus?: boolean;
  errorMessage: string;
  fieldName: string;
  label: string;
  requiredPlaceholder?: string;
}): JSX.Element | null {
  return (
    <Field
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, onBlur) => (
        <Input
          autoFocus={autoFocus}
          className="w-48"
          inError={inError}
          onBlur={onBlur}
          onChange={onChange}
          required={Boolean(errorMessage)}
          requiredPlaceholder={requiredPlaceholder}
          value={value}
        />
      )}
      fieldName={fieldName}
      fieldValidations={{ required: errorMessage }}
      label={label}
    />
  );
}

export default ResNumber;
